import { GameListConfigType } from '../types/game.type';

export const GAME_LIST_REQUEST_LIMIT = 30;

export const lastPlayedListConfig: GameListConfigType = {
  gameList: [],
  title: 't.last-played',
  link: '/casino/last-played',
  type: 'last-played',
};

export const favoriteListConfig: GameListConfigType = {
  filter: {
    limit: GAME_LIST_REQUEST_LIMIT,
  },
  title: 'cat.favorite',
  link: '/casino/favorite',
  type: 'favorite',
};
